import { Briefcase, GraduationCap } from "lucide-react";
import { Images } from "../assets/images";

const Experience = () => {
  return (
    <section id="experience" className="py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Formation & Expérience
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto mb-8"></div>
          <p className="text-lg text-foreground/80">
            Mon parcours académique et professionnel dans le domaine du
            développement web et mobile.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Formation */}
          <div>
            <div className="flex items-center mb-8">
              <GraduationCap size={28} className="text-primary mr-4" />
              <h3 className="text-2xl font-bold">Formation</h3>
            </div>

            <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-1/2 before:w-0.5 before:bg-muted">
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-primary rounded-full"></div>
                </div>

                <div className="bg-card p-6 rounded-lg shadow-md">
                  <div className="flex flex-wrap justify-between items-center mb-2">
                    <h4 className="text-xl font-semibold">
                      Formation Développeur Fullstack Node.js
                    </h4>
                    <span className="text-sm font-medium text-foreground/60">
                      2023 - 2024
                    </span>
                  </div>
                  <p className="text-foreground/70 mb-4">
                    Centre de Formation{" "}
                    <span className="font-bold">GetSmarter</span>
                  </p>
                  <ul className="list-disc list-inside text-foreground/70 space-y-2">
                    <li>HTML, CSS, JavaScript, TypeScript</li>
                    <li>React, Node.js, Express, NestJS</li>
                    <li>SQL, MongoDB</li>
                    <li>Modélisation UML et analyse de projets</li>
                    <li>UI/UX Design</li>
                  </ul>
                </div>
              </div>

              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-primary rounded-full"></div>
                </div>

                <div className="bg-card p-6 rounded-lg shadow-md">
                  <div className="flex flex-wrap justify-between items-center mb-2">
                    <h4 className="text-xl font-semibold">
                      Baccalauréat Scientifique
                    </h4>
                    <span className="text-sm font-medium text-foreground/60">
                      2022 - 2023
                    </span>
                  </div>
                  <p className="text-foreground/70 mb-4">
                    Lycée Bilingue de Bonaberi
                  </p>
                  <p className="text-foreground/70">
                    Formation générale avec spécialisation en mathématiques et
                    sciences.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Expérience */}
          <div>
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-primary/20">
                <img
                  src={Images.hero3}
                  alt="Expérience professionnelle"
                  className="w-full h-full object-cover"
                />
              </div>
              <Briefcase size={28} className="text-primary mr-4" />
              <h3 className="text-2xl font-bold">Expérience</h3>
            </div>

            <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-1/2 before:w-0.5 before:bg-muted">
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-primary rounded-full"></div>
                </div>

                <div className="bg-card p-6 rounded-lg shadow-md">
                  <div className="flex flex-wrap justify-between items-center mb-2">
                    <h4 className="text-xl font-semibold">
                      Projet d'Entreprise
                    </h4>
                    <span className="text-sm font-medium text-foreground/60">
                      2024
                    </span>
                  </div>
                  <p className="text-foreground/70 mb-4">
                    Entreprise SAWA sarl
                  </p>
                  <p className="text-foreground/70 mb-4">
                    Stage de fin de formation où j'ai participé au développement
                    d'une application fullstack web et mobile en utilisant les
                    technologies Node.js, React, React Native et TypeScript.
                  </p>
                  <ul className="list-disc list-inside text-foreground/70 space-y-2">
                    <li>
                      Développement de fonctionnalités frontend avec React
                    </li>
                    <li>Création d'APIs RESTful avec NestJS</li>
                    <li>Intégration avec une base de données MySQL</li>
                    <li>
                      Participation aux réunions d'équipe et aux revues de code
                    </li>
                  </ul>
                </div>
              </div>

              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-primary rounded-full"></div>
                </div>

                <div className="bg-card p-6 rounded-lg shadow-md">
                  <div className="flex flex-wrap justify-between items-center mb-2">
                    <h4 className="text-xl font-semibold">
                      Projets Personnels
                    </h4>
                    <span className="text-sm font-medium text-foreground/60">
                      2023 - Présent
                    </span>
                  </div>
                  <p className="text-foreground/70 mb-4">Autoformation</p>
                  <p className="text-foreground/70">
                    Développement de projets personnels pour approfondir mes
                    connaissances et explorer de nouvelles technologies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
